import React from "react";
import { Link } from "react-router-dom";
import "./gender.css";
import { connect } from "react-redux";
import { selectGender } from "../../../Redux/action";
import ProfileNavbar from "../../../components/Navbar/ProfileNavbar";
import Footer from "../../../components/Footer/Footer";

const Gender = ({ selectGender, state }) => {
  const handleGender = (e) => {
    selectGender(e.target.name);
    //console.log(state);
  };

  return (
    <>
      <ProfileNavbar />
      <div className="gender">
        <h1>Please take time to answer these Questions.</h1>
        <div className="select">
          <h3>What is your gender??</h3>
          <button name="female" onClick={(e) => handleGender(e)}>
            <Link to="/age" className="male">
              {" "}
              Female
            </Link>
          </button>

          <button name="male" onClick={(e) => handleGender(e)}>
            <Link to="/age" className="male">
              Male
            </Link>
          </button>

          <button name="others" onClick={(e) => handleGender(e)}>
            <Link to="/age" className="male">
              Others
            </Link>
          </button>
          <button name="prefer not to say" onClick={(e) => handleGender(e)}>
            <Link to="/age" className="male">
              Prefer not to say
            </Link>
          </button>
        </div>
      </div>
      <Footer />
    </>
  );
};

let mapDispatchToProps = { selectGender };
let mapStateToProps = (state) => {
  return { state };
};

export default connect(mapStateToProps, mapDispatchToProps)(Gender);
